import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { Home, LoginPage, RegisterPage, ConfirmEmailPage, PlansPage, AccountPage, NotFound, PaymentSuccessPage, PaymentCancelPage, ForgotPasswordPage, ResetPasswordPage, AdminPage } from "../../pages";
import { FDDApp } from "../../FDDApp";
import DraftWrapper from "../../pages/draft/components/Wrapper.jsx";
import { RouteProvider } from "./context/RouteProvider";
import { SignatureWrapper } from "../../pages/signature/components/Wrapper";

const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/">
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="confirm-email" element={<ConfirmEmailPage />} />

          {/* Firma de documentos: accesible a invitados sin cuenta */}
          <Route element={<FDDApp />}>
            <Route path="signature/:hash" element={<SignatureWrapper />} />
          </Route>

          {/* Rutas con Navbar pero sin autenticación requerida */}
          <Route element={<FDDApp />}>
            <Route path="plans" element={<PlansPage />} />
          </Route>

          {/* Páginas de retorno de PayPal (sin navbar) */}
          <Route path="payment/success" element={<PaymentSuccessPage />} />
          <Route path="payment/cancel" element={<PaymentCancelPage />} />

          {/* Recuperación de contraseña (sin navbar ni autenticación) */}
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />

          {/* Ruta protegida */}
          <Route element={<ProtectedRoute />}>
            {/* FDDApp como layout que incluye Navbar */}
            <Route  element={<RouteProvider> <FDDApp/> </RouteProvider>}>
              {/* Rutas debajo del Navbar */}
              <Route index element={<Home />} />
              <Route path="account" element={<AccountPage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="draft/:hash" element={<DraftWrapper/>} />
              {/* Puedes añadir más rutas aquí */}
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
      </Route>
    )
  );

export default router;